import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { TriggerType } from 'sections/onsite-campaigns/types';

export const useAddTriggerType = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((type: TriggerType) => dispatch({ type: 'SET_SELECTED_TRIGGER_TYPE', payload: { type } }), [
    dispatch,
  ]);
};
